import React from 'react';
import { saveAs } from 'file-saver';
import Papa from 'papaparse';

const ExportButton = ({ data = [], filename = 'expenses.csv' }) => {
  const onExport = () => {
    const csv = Papa.unparse(data);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, filename);
  };
  return <button className="btn secondary" onClick={onExport}>Export CSV</button>;
};

export default ExportButton; 